import { c as _c } from "react-compiler-runtime";
import { useEffect, useMemo, useState } from "react";
import { debounce } from "@/core/utils/helpers.utils";
type UseOnScrollResult = {
  scrolled: boolean;
};
type UseOnScrollProps = {
  distance: number;
  callback?: (e: unknown) => void;
};
export default function useOnScroll(t0) {
  const $ = _c(10);
  const {
    distance,
    callback
  } = t0;
  const t1 = callback ?? _temp;
  let t2;
  if ($[0] !== t1) {
    t2 = debounce(50, t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const cb = t2;
  let t3;
  if ($[2] !== distance) {
    t3 = () => {
      if (typeof window === "undefined") {
        return false;
      }
      return window.scrollY >= distance;
    };
    $[2] = distance;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [scrolled, setScrolled] = useState(t3);
  let t4;
  let t5;
  if ($[4] !== cb || $[5] !== distance) {
    t4 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const handleScroll = e => {
        setScrolled(window.scrollY >= distance);
        cb(e);
      };
      document.addEventListener("scroll", handleScroll);
      queueMicrotask(() => handleScroll(new Event("scroll")));
      return () => document.removeEventListener("scroll", handleScroll);
    };
    t5 = [cb, distance];
    $[4] = cb;
    $[5] = distance;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== scrolled) {
    t6 = {
      scrolled
    };
    $[8] = scrolled;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp() {}